import { Button, TextInput, TagInput, Select } from '@common/components';
import { useForm } from '@mantine/form';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ISiteListData, _updateAdSiteList, addSiteList, currentAction, getOwnCompanies, updateCurrent, useAppDispatch, useAppSelector } from 'src/store';
import styles from './styles.module.scss';
import { checkValidHttps } from '@common/helpers/checkValidHttps';
import { useAlert, useFormFocus } from '@common/hooks';
import { FC, useEffect, useId, useState } from 'react';
import { shallowEqual } from 'react-redux';
import { Flex } from '@mantine/core';

interface Props {
  changeFormState: (value:string) => void;
  listItems: ISiteListData[] | [];
  canDisplayButton: boolean;
  style?: any;
  companyId?: any;
  isAccountPage?: any;
}

const AddSiteFormIssuePage: FC<Props> = ({ changeFormState, listItems, canDisplayButton, style, isAccountPage }) => {
  // const { loading } = useAppSelector((state) => state.siteList, shallowEqual);
  const { getOwnCompaniesdata } = useAppSelector((state) => state.organization, shallowEqual);
  // const { company_id } = useAppSelector((state) => state.user.data, shallowEqual);


  const [ companiesList , setCompaniesList ] = useState<any>([])
  const [ saveLoading , setSaveLoading ] = useState(false)
  const [t] = useTranslation('siteList');
  const dispatch = useAppDispatch();
  const { showAlert } = useAlert()

  const form = useForm({
    initialValues: {
      websiteUrl: '',
      company: ''
      // companyId: companyId
    },
    transformValues: (values:any) => {
      let newUrl;
      const urlPattern = /^((http|https):\/\/)/;

      if (!urlPattern.test(values.websiteUrl)) {
        newUrl = 'https://' + values.websiteUrl;
      }
      return {
        websiteUrl: newUrl || values.websiteUrl,
        company: values.company
      };
    },
    validate: {
      websiteUrl: (value) => {
        if (!checkValidHttps(value?.trim())) {
          setNeedFocus(true);
          return t('notValid'); // Return translation for an invalid URL
        }

        // Check if the normalized URL already exists in the listItems
        if (listItems.some(e => e.websiteUrl === value?.trim())) {
          setNeedFocus(true);
          return t('alreadyExists'); // Return translation that URL already exists
        }

        return null; // No error, URL is valid and does not exist
      },
      company: (value) => {
        console.log(value);
        
        if(!companiesList.length){
          return 'You should create a company first';
        }
        if (!value) {
          return 'Website must belong to a company'
        }
      }
    },

  });

  const { setNeedFocus } = useFormFocus({ formErrors: form.errors });



  // for screen reader.
  useEffect(() => {
    if (form?.errors?.websiteUrl) {
      const errorMessage = document.querySelector('.mantine-InputWrapper-error');
      if (errorMessage) {
        errorMessage.role = 'status'
        errorMessage.ariaLive = 'polite'
        errorMessage.ariaAtomic = 'true'
      }
    }
  }, [form?.errors?.invited_company_owner_email]);

  useEffect(() => {
    return () => {
     
      form.reset();
      dispatch(_updateAdSiteList());
    }
  }, [])

  useEffect( () => {


    if (!getOwnCompaniesdata) {
      dispatch(getOwnCompanies());
    }

    if ( getOwnCompaniesdata ) {
      const data = getOwnCompaniesdata?.map((company:any) => ( { label : company.company_name , value : company?.id}))

      setCompaniesList(data);
      form.setValues({
        company: data.length ?  data[0].value : ''
      });
    }
  } ,[getOwnCompaniesdata])
  return (
    <div className={styles['w-full']}>
      <form
        style={style}
        className={classNames(styles['form-container'])}
        onSubmit={form.onSubmit((values) => {
          // if (canDisplayButton) {
            form.clearErrors()
            // dispatch(_updateAdSiteList())
            // console.log( values );
            setSaveLoading(true)
            dispatch(addSiteList({values ,companyId:values?.company,isAccountPage , submitCallback: () => {
              showAlert({
                id: 'site-added',
                title: 'Site Added Success',
                message: `${form.values.websiteUrl} Has Been Added Successfully.`,
                variant: 'success',
                autoClose: 2000
              });
              dispatch(currentAction());
              changeFormState("");
              setSaveLoading(false)
            } , 
            errorCallback : (error:string) => {
              // console.log( error );
              setSaveLoading(false)
              setNeedFocus(true);
              showAlert({
                id: error,
                title: 'Something went wrong!!',
                message: error == "Report tool site creation failed" ? error + ' Or Site does not exist' : error,
                variant: 'error',
                autoClose: 2000
              });
              form.setFieldError('websiteUrl', error == "Report tool site creation failed" ? error + ' Or Site does not exist' : error)
            }
          
          } )); 
          // }
        })}>
        <Flex w={"100%"} direction={"column"} gap={"sm"}>

          <TextInput
            autoFocus
            className={classNames(styles['grow'])}
            label={`${t('inputLabel')}`}
            placeholder={`${t('inputPlaceholder')}`}
            {...form.getInputProps('websiteUrl')}
          />
          <Select
            width='100%'
            maxWidth="100%"
            variant="secondary"
            sx={{
              '.mantine-Select-dropdown': {
                width: '350px !important',
              },
            }}
            label='Company'
            withIcon
            data={companiesList ?? []}
            {...form.getInputProps('company')}
          />
        </Flex>
        {/* <TagInput
          value={['test']}  // assuming `tags` is part of your form's state
          onChange={(newTags: any) => form.setFieldValue('tags', newTags)}
          placeholder={`${t('Enter Tag (s)')}`}
          className={classNames(styles['grow'])}
/> */}
        <Button
          loading={saveLoading}
          className={classNames(styles['add-site'])} type={'submit'}>
          {t('btnSave')}
        </Button>
        <Button

          className={classNames(styles['add-site'])}
          color={'dark-green'}
          onClick={() => {
            changeFormState('cancel');
            form.reset();
          }}>
          {t('btnCancel')}
        </Button>
      </form>
    </div>
  );
};

export default AddSiteFormIssuePage;
